import { AbstractClone } from "../../abstract/clone.abstract";
import { Injectable, Injector } from "@angular/core";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { CloneService } from "./clone.service";
import { WidgetsSectionModel } from "src/app/models/widgets/widgets-section.model";
import { WidgetsFormModel } from "src/app/models/widgets/widgets-form.model";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";

@Injectable({
  providedIn: 'root'
})
export class CloneSectionService extends AbstractClone {

  constructor(private injector: Injector) {
    super();
  }

  cloneFromJS(origWidget: any,
    parentWidget: WidgetsAbstract,
    isDragNDrop: boolean,
    isInsideQuestion: boolean,
    parentId: string | undefined) {
    const origSection = origWidget as WidgetsSectionModel;
    const parentContainer = parentWidget as WidgetsContainerAbstract;

    // Retrieve from injector to avoid circular dependency
    const widgetsCloneService = this.injector.get(CloneService);

    if (!isDragNDrop) {
      // Cloning from JSON to TypeScript        
      const newSection = new WidgetsSectionModel();
      newSection.cloneFrom(origSection);
      newSection.parentId = parentId;
      parentContainer.children.push(newSection);
      origSection.children.forEach(childQuestion => {
        widgetsCloneService.cloneFromJS(childQuestion, newSection, isDragNDrop, isInsideQuestion, newSection.id);
      });
    } else {
      // Section dropped Canvas. Clone from TypeScript to TypeScript
      const newSection = parentWidget as WidgetsSectionModel;     
      origSection.children.forEach(childQuestion => {
        // Take care, it's the generic one here
        widgetsCloneService.cloneFromJS(childQuestion, parentWidget!, isDragNDrop, isInsideQuestion, newSection.id);
      });      
    }
  }
}
